import React from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

// add google analytics https://github.com/react-ga/react-ga/issues/122
ReactGA.initialize('UA-27475959-1');

class GAListener extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  componentDidMount() {
    this.sendPageView(this.context.router.history.location);
    this.context.router.history.listen(this.sendPageView);
  }

  /* eslint-disable class-methods-use-this */
  sendPageView(location) {
    // send a pageview only on danohlsen.com
    if (window.location.hostname === 'danohlsen.com') {
      ReactGA.set({ page: location.pathname });
      ReactGA.pageview(location.pathname);
      // console.log(`send a pageview for ${location.pathname}`);
    }
  }
  /* eslint-enable class-methods-use-this */

  render() {
    return this.props.children;
  }
}

export default GAListener;



// WEBPACK FOOTER //
// ./src/components/GAListener.js